<ion-content class="ion-text-center ion-vertical-align-content marketingContent">
    <div>
        <ion-grid>
            <ion-row>
                <ion-col class="marketingImage" data-test="marketingImage">
                    <img src="./assets/images/roi.png" />
                </ion-col>
            </ion-row>

            <ion-row class="marketingCopy">
                <!-- <ion-col class="ion-align-self-center"> -->
                <ion-col>
                    <p>  <!-- <br /><br /> -->
                        ShuttleNomix is the smart, automated shuttle solution built for car dealerships. 
                        It cuts labor costs, eliminates pricey ride-shares, and gets customers moving faster.
                    </p>
                    <p>
                        By connecting customers, service advisors, and drivers in real time, ShuttleNomix 
                        keeps everyone informed, happy, and hassle-free. No more dropped communication.
                    </p>
                    <p>
                        Keep offering free rides and start generating revenue! With ROI measured in hours 
                        and zero upfront costs, you'll see the value on day one. Risk-free and profit-ready.
                    </p>
                    <p>
                        <ion-button expand="block" class="login" #loginButton1 (click)="onLoginClick()" data-test="login1">
                            {{vm.loginText}}
                        </ion-button>
                    </p>
                </ion-col>
            </ion-row>
        </ion-grid>
    </div>
</ion-content>

<!-- My original version of the text:
ShuttleNomix, designed specifically for car dealerships, 
delivers an automated, customer-centric shuttle 
solution. It lowers labor costs, eliminates the high-cost of ride-share
and reduces customer wait times. <br /><br />

By placing customers in the conversation loop between service advisors and 
drivers, ShuttleNomix keeps them well-informed and complaint-free 
while automatically handling all necessary communications. <br /><br />

You can still give away free shuttle rides and <strong>Generate Revenue!</strong> 
With ROI measured in hours, you'll see the value exceeds the cost on day one, 
making it a logical business choice — especially when you don't pay a cent 
until you see the proof in your own service department.
-->

<!-- 
1️⃣ Tech-Driven & Modern Tone

ShuttleNomix is the next-gen, automated shuttle platform built for dealerships that want speed, efficiency, and customer satisfaction. It streamlines operations, slashes labor costs, and replaces expensive ride-shares with smart automation.

By syncing customers, advisors, and drivers in one seamless loop, ShuttleNomix keeps everyone connected in real time — no delays, no confusion, just smooth communication from drop-off to pickup.

Keep offering free rides and turn them into revenue. With instant ROI and no upfront cost, ShuttleNomix proves its value from day one — innovation that pays for itself.

-->
<!--
2️⃣ Business-Focused & ROI-Driven Tone

ShuttleNomix gives car dealerships a smarter, more profitable way to manage shuttles. It reduces labor expenses, eliminates costly ride-share fees, and shortens customer wait times.

By automating communication between customers, advisors, and drivers, ShuttleNomix prevents complaints, increases satisfaction, and improves service efficiency.

Continue offering free rides while adding a new revenue stream. With measurable ROI in hours and no payment until results are proven, ShuttleNomix delivers immediate financial impact — a clear win for your bottom line.
-->

